var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"200px"}},[_vm._v(" dsadsa ")])}
var staticRenderFns = []

export { render, staticRenderFns }